export const covanceExcelStyles = [
    {
        id: 'alwaysString',
        dataType: 'string'
    }
];